const REP_TYPE_HOLIDAY = 'holidayreport'
const REP_TYPE_DISTANCE = 'distancereport'
const REP_TYPE_LOG = 'logreport'
const REP_TYPE_TIMESHEET = 'timesheetreport'
const REP_TYPE_SUMMARY = 'summaryreport'
const REP_TYPE_ADV = 'advreport'

export const REP_TYPES = { REP_TYPE_HOLIDAY, REP_TYPE_DISTANCE, REP_TYPE_LOG, REP_TYPE_TIMESHEET, REP_TYPE_SUMMARY, REP_TYPE_ADV }